/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  PersonInfo,
  PersonGroupMember,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  personInfoSchema,
  personGroupMemberSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
  personInfoJsonSchema,
  personGroupMemberJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, ApplicationEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, ApplicationSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, ApplicationJsonSchema } from './enumLib_api';
export const clientInfoSchema = z.object({
	browserAgent: z.string(),
	platform: z.string(),
	browserCodeName: z.string(),
	applicationId: ApplicationSchema,
	version: z.string(),
	extra: z.string()
});

export const clientInfoJsonSchema = z.object({
	browserAgent: z.string().describe("Browser information"),
	platform: z.string().describe("Android or IOS or ... with version number"),
	browserCodeName: z.string().describe("Firefox, Chrome...."),
	applicationId: ApplicationJsonSchema,
	version: z.string(),
	extra: z.string().describe("Free text")
}).describe("Information about the application and evironment where the exception occurred (corresponds to the C# class PdcLogSysInfo)");

/**
	Information about the application and evironment where the exception occurred (corresponds to the C# class PdcLogSysInfo)
	Responsible: PM, Updated: 20181107
*/
export class ClientInfo {
	constructor(
		/** Browser information */
		public browserAgent: string,
		/** Android or IOS or ... with version number */
		public platform: string,
		/** Firefox, Chrome.... */
		public browserCodeName: string,
		public applicationId: ApplicationEnum,
		public version: string,
		/** Free text */
		public extra: string,
	) {}
}

export const lineInfoSchema = z.object({
	file: z.string(),
	line: z.int()
});

export const lineInfoJsonSchema = z.object({
	file: z.string(),
	line: z.int()
}).describe("A line in a Prolog-like stacktrace");

/**
	A line in a Prolog-like stacktrace
	Responsible: PM, Updated: 20181107
*/
export class LineInfo {
	constructor(
		public file: string,
		public line: number,
	) {}
}

/**
	Send an exception to the notification log, with an explicit groupon argument Prefer this logging method in javascript and typescript, where the stacktrace is a bad mechanism for grouping exceptions
	Responsible: LABO, Updated: 20190130
*/
export class Log2 extends WebRequest<boolean> {
	public readonly webService = "NotificationLog";
	public readonly method = "Log2";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public groupOn: string,
		public exceptionName: string,
		public exceptionMsg: string,
		public userComment: string,
		public clientInfo: ClientInfo,
	) {
		super();
	}

	public static readonly create = (x: {groupOn: string, exceptionName: string, exceptionMsg: string, userComment: string, clientInfo: ClientInfo}): Log2 => {
        return new Log2(x.groupOn, x.exceptionName, x.exceptionMsg, x.userComment, x.clientInfo);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(Log2.returnSchema, json) as unknown as boolean;
	}
}

/**
	Send an exception to the notification log, and group the exception as if it occurred in a Prolog program Prefer this logging method if the stacktrace is a good mechanism for grouping exceptions
	Responsible: PM, Updated: 20181107
*/
export class Log extends WebRequest<boolean> {
	public readonly webService = "NotificationLog";
	public readonly method = "Log";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public exceptionName: string,
		public exceptionMsg: string,
		public stacktrace: LineInfo[],
		public userComment: string,
		public clientInfo: ClientInfo,
	) {
		super();
	}

	public static readonly create = (x: {exceptionName: string, exceptionMsg: string, stacktrace: LineInfo[], userComment: string, clientInfo: ClientInfo}): Log => {
        return new Log(x.exceptionName, x.exceptionMsg, x.stacktrace, x.userComment, x.clientInfo);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(Log.returnSchema, json) as unknown as boolean;
	}
}

export const Log2AI = { key: 'NotificationLog_Log2' as const,
          webService: 'NotificationLog' as const,
           method: 'Log2' as const,
           description: "Send an exception to the notification log, with an explicit groupon argument Prefer this logging method in javascript and typescript, where the stacktrace is a bad mechanism for grouping exceptions",
           inputJsonSchema: z.object({ groupOn: z.string(), exceptionName: z.string(), exceptionMsg: z.string(), userComment: z.string(), clientInfo: z.lazy(() => clientInfoJsonSchema)}),
           inputSchema: z.object({ groupOn: z.string(), exceptionName: z.string(), exceptionMsg: z.string(), userComment: z.string(), clientInfo: z.lazy(() => clientInfoSchema)}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: Log2
          }
export const LogAI = { key: 'NotificationLog_Log' as const,
          webService: 'NotificationLog' as const,
           method: 'Log' as const,
           description: "Send an exception to the notification log, and group the exception as if it occurred in a Prolog program Prefer this logging method if the stacktrace is a good mechanism for grouping exceptions",
           inputJsonSchema: z.object({ exceptionName: z.string(), exceptionMsg: z.string(), stacktrace: z.array(z.lazy(() => lineInfoJsonSchema)), userComment: z.string(), clientInfo: z.lazy(() => clientInfoJsonSchema)}),
           inputSchema: z.object({ exceptionName: z.string(), exceptionMsg: z.string(), stacktrace: z.array(z.lazy(() => lineInfoSchema)), userComment: z.string(), clientInfo: z.lazy(() => clientInfoSchema)}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: Log
          }
export const endpoints = [Log2AI, LogAI] as const;
export type Endpoint = (typeof endpoints)[number];
